import { KeyContactItem } from "./KeyContactItem";

export default KeyContactItem;